module.exports = "/assets/about/second_section_1.png?qse9fIK";